import { TableCell as MuiTableCell, withStyles } from '@material-ui/core';

const TableCell = withStyles({
  root: {
    padding: '1em'
  }
})(MuiTableCell);

export default TableCell;
